import { FC } from "react";
import { FaYoutube } from "react-icons/fa";
import styled from "styled-components";

const NoWrap = styled.div`
  align-items: center;
  display: flex;
  white-space: nowrap;
`;

const YouTubeIcon = styled(FaYoutube)`
  width: 20px;
  height: 20px;
  color: white;
`;

type YouTubeProps = {};

export const YouTube: FC<YouTubeProps> = () => {
  return (
    <NoWrap>
      <a
        href="https://www.youtube.com/@Enefelthegame"
        target="_blank"
        rel="noopener noreferrer"
      >
        <YouTubeIcon />
      </a>
    </NoWrap>
  );
};
